import { HttpLink } from '@apollo/client';

import { envSwitch } from '@/utils/environmentUtils';

const uri = envSwitch({
  local: 'http://localhost:8000/graphql/',
  dev: 'https://cortex.bighealthdev.com/dev/graphql/',
  qa: 'https://cortex.bighealthdev.com/qa/graphql/',
  stage: 'https://cortex.bighealthstage.com/stage/graphql/',
  prod: 'https://cortex.bighealth.com/prod/graphql/',
  pr: 'https://cortex.bighealthdev.com/dev/graphql/',
});

export const httpLink = new HttpLink({
  uri,
  credentials: 'same-origin',
});
